import { apiClient } from './apiClient';

const BASE_URL = (process.env.REACT_APP_API_URL || 'http://localhost:3001/api').replace(/\/api\/?$/, '');

/**
 * Получить полный URL изображения услуги
 */
export function getServiceImageUrl(image: string | undefined): string | null {
  if (!image) return null;
  return `${BASE_URL}/static/${image}`;
}

export interface MedicalService {
  id: string;
  name: string;
  description?: string;
  status: number;
  image?: string;
  branches?: { id: string; name: string }[];
  categories?: ServiceCategory[];
}

export interface ServiceCategory {
  id: string;
  name: string;
  index: number;
}

export interface CollageImage {
  image: string;
}

export interface ServiceCollage {
  id: string;
  images: string[];
}

export interface ServiceDoctor {
  id: string;
  name: string;
  specializations?: string[];
}

/**
 * Medical services API client
 */
export const servicesService = {
  /**
   * Получить все категории услуг
   */
  getCategories: () => {
    return apiClient.get<{ categories: ServiceCategory[] }>('/webapp/services/categories');
  },

  /**
   * Получить услуги по категории
   */
  getServicesByCategory: (categoryId: string) => {
    return apiClient.get<{ services: MedicalService[] }>(`/webapp/services/category/${categoryId}`);
  },

  /**
   * Получить все услуги текущего филиала
   */
  getAllServices: () => {
    return apiClient.get<{ services: MedicalService[] }>('/webapp/services/');
  },

  /**
   * Получить информацию об услуге
   */
  getService: (serviceId: string) => {
    return apiClient.get<{ service: MedicalService }>(`/webapp/services/${serviceId}`);
  },

  /**
   * Получить врачей для услуги
   */
  getServiceDoctors: (serviceId: string) => {
    return apiClient.get<{ doctors: ServiceDoctor[] }>(`/webapp/services/${serviceId}/doctors`);
  },

  /**
   * Получить коллаж работ (до/после)
   */
  getServiceCollage: (serviceId: string) => {
    return apiClient.get<{ collage: any; images: string[] }>(`/webapp/services/${serviceId}/collage`);
  },

  /**
   * Получить рекомендации к подготовке
   */
  getServicePreparation: (serviceId: string) => {
    return apiClient.get<{ guides: any[] }>(`/webapp/services/${serviceId}/preparation`);
  },
};

